import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';

import { Observable } from 'rxjs';

import { TranslateService } from '@ngx-translate/core';

import { CenterInfo } from '@models/center/info/center-info';

import { SessionService } from '@services/utils/session.service';
import { NotificationService } from '@services/utils/notification.service';
import { MemberFeeService } from '@services/private';

@Injectable({
    providedIn: 'root'
})
export class SubscriptionCheckService {
    private readonly router = inject(Router);
    private readonly memberFeeService = inject(MemberFeeService);
    private readonly sessionService = inject(SessionService);
    private readonly translateService = inject(TranslateService);
    private readonly notificationService = inject(NotificationService);

    checkSubscription(): Observable<boolean> {
        return new Observable<boolean>(
            observable => {
                const centerInfo: CenterInfo = this.sessionService.getCenterInfo();
                if (centerInfo.paymentConfiguration.isActiveSubscription) {
                    this.memberFeeService.searchMemberFees().subscribe(
                        fees => {
                            if (fees.length === 0) {
                                this.translateService.get(['error_subscription_required']).subscribe(
                                    translate => {
                                        this.notificationService.showErrorMessage(translate.error_subscription_required);
                                        this.router.navigateByUrl('/customer/subscriptions/shop');
                                    }
                                );

                                observable.next(false);
                            } else {
                                observable.next(true);
                            }
                        }
                    );
                } else {
                    observable.next(true);
                }
            }
        );
    }
}

